import "./SidebarDiwaliJhalar.css";

const colors = [
  { fill: "#ffd84d", glow: "rgba(255, 200, 48, 0.9)" },
  { fill: "#ff9b45", glow: "rgba(255, 132, 48, 0.9)" },
  { fill: "#bd83e6", glow: "rgba(177, 111, 230, 0.9)" },
  { fill: "#ff8cb8", glow: "rgba(255, 121, 174, 0.9)" },
  { fill: "#8fd8ff", glow: "rgba(100, 195, 255, 0.9)" },
  { fill: "#fff4d6", glow: "rgba(255, 240, 202, 0.95)" },
];

const bulbs = Array.from({ length: 39 }, (_, index) => {
  const progress = index / 38;
  const angle = progress * Math.PI * 8;
  return {
    x: 10 + Math.sin(angle) * 2.1,
    y: 12 + progress * 976,
    fill: colors[index % colors.length].fill,
    glow: colors[index % colors.length].glow,
    delay: `${((index % 2) * 0.55 + (index * 0.047) % 0.28).toFixed(2)}s`,
  };
});

export default function SidebarDiwaliJhalar() {
  return (
    <div className="sidebar-diwali-jhalar" aria-hidden="true">
      <svg className="sidebar-diwali-jhalar-art" viewBox="0 0 20 1000" preserveAspectRatio="none">
        <path className="sidebar-diwali-jhalar-wire" d="M10 0 C15 83 5 167 10 250 C15 333 5 417 10 500 C15 583 5 667 10 750 C15 833 5 917 10 1000" />
        {bulbs.map((bulb, index) => (
          <circle
            key={index}
            className="sidebar-diwali-jhalar-led"
            cx={bulb.x}
            cy={bulb.y}
            r="2.1"
            style={{
              "--sidebar-diwali-jhalar-color": bulb.fill,
              "--sidebar-diwali-jhalar-glow": bulb.glow,
              "--sidebar-diwali-jhalar-delay": bulb.delay,
            }}
          />
        ))}
      </svg>
    </div>
  );
}
